import type { ReactNode } from 'react'
import { Header } from './Header'

export interface NavigationItem {
  key: string
  label: string
  icon?: string
}

interface LayoutProps {
  title: string
  subtitle: string
  roleSwitcher?: {
    value: 'teacher' | 'student'
    onChange: (role: 'teacher' | 'student') => void
  }
  navItems?: NavigationItem[]
  activeNavKey?: string
  onNavigate?: (key: string) => void
  installButton?: {
    onClick: () => void
  }
  children: ReactNode
}

export const Layout = ({
  title,
  subtitle,
  roleSwitcher,
  navItems,
  activeNavKey,
  onNavigate,
  installButton,
  children,
}: LayoutProps) => (
  <main className="app-shell">
    <Header
      title={title}
      subtitle={subtitle}
      roleSwitcher={roleSwitcher}
      installButton={installButton}
    />

    <section className="screen-content">{children}</section>

    {navItems && navItems.length > 0 ? (
      <nav className="bottom-nav" aria-label="Навигация">
        {navItems.map((item) => (
          <button
            type="button"
            key={item.key}
            className={item.key === activeNavKey ? 'active' : undefined}
            onClick={() => onNavigate?.(item.key)}
          >
            {item.icon ? <span className="nav-icon" aria-hidden="true">{item.icon}</span> : null}
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    ) : null}
  </main>
)
